/**
 * Horizontal Tabbed Panel Block
 * 
 * @class rlHoriTabbedPanel
 * @memberOf jQuery.fn
 * 
 */

(function ($) {
  $.fn.rlHoriTabbedPanel = function () {

      const navanchor = $('.horitabbedpanelblock .panelnav .tab'),
            accordionanchor = $('.horitabbedpanelblock .horitabbedpanelblock__accordion-heading .horitabbedpanelblock__button'),
            focuselements = 'a, button, iframe, .youtubeapi',
            contentpanel = $('.horitabbedpanelblock .panel');

      $('.horitabbedpanelblock').each(function(){
        setLastPanelOpened(this, '');
      });
       
      //on load set content panel tabindex
      contentpanel.find(focuselements).attr('tabindex', '-1');

      // if comparison table block is used wait for slick to load (mobile)
      $('.comparison-mobile').on('init', function (event, slick) {
          contentpanel.find(focuselements).attr('tabindex', '-1');
      });

      //on load set first tab and panel as active     
      $('.horitabbedpanelblock .panelnav li:first-of-type').addClass('active').attr('aria-selected', 'true').attr('tabindex', '0');
      $('.horitabbedpanelblock .panel:first-of-type').addClass('active').attr('aria-hidden', 'false').attr('tabindex', '0').find(focuselements).removeAttr('tabindex');
      if ($('.horitabbedpanelblock .panelnav').css('display') != 'none') {
          $('.horitabbedpanelblock .panel:first-of-type').addClass('active').attr('aria-hidden', 'false').attr('tabindex', '0').find(focuselements).removeAttr('tabindex');
      }
      else {
          accordionanchor.removeClass('active').attr('aria-expanded', 'false');
          contentpanel.removeClass('active').attr('aria-hidden', 'true').attr('tabindex', '-1').find(focuselements).attr('tabindex', '-1');
      }

      navanchor.on('click', function () {
          horitabbedclickevent(this);
      });

      accordionanchor.on('click', function () {          
          accordionclickevent(this);
      });

      //Accessibility
      contentpanel.focusin(function () {
          let el_panel = $(this).data('id');

          if ($(document.activeElement).hasClass('panel')) {
            $(this).addClass('focused');
          }

          //setting conditional statement here fixes active_element bug within ie11
          if ($(this).hasClass('focused')) {
            $(this).parents('.horitabbedpanelblock').find('.tab[aria-controls="' + el_panel + '"]').addClass('focused');
          }

          $(this).prev('.panelnav').children('.tab').attr('tabindex', '-1');
          $(this).prev('.panelnav').children('.tab.active').attr('tabindex', '0');
        
      }).focusout(function () {
          let el_panel = $(this).data('id');

          $(this).removeClass('focused');
          if (!$(this).hasClass('focused')) {
            $(this).parents('.horitabbedpanelblock').find('.tab[aria-controls="' + el_panel + '"]').removeClass('focused');
        }

      });

      //custom keyboard mapping - horizontal tabbed
      navanchor.on('keydown', function (e) {

          function firstchild(el) {
            $(el).attr('tabindex', '-1').parent('ul').children('li:first-of-type').attr('tabindex', '0').focus();
          }
          function lastchild(el) {
            $(el).attr('tabindex', '-1').parent('ul').children('li:last-of-type').attr('tabindex', '0').focus();
          }
          function nextchild(el) {
            $(el).attr('tabindex', '-1').next('li').attr('tabindex', '0').focus();
          }
          function prevchild(el) {
            $(el).attr('tabindex', '-1').prev('li').attr('tabindex', '0').focus();
          }

          //var keycode = e.which;
          var keycode = (e.keyCode ? e.keyCode : e.which);
          
          //spacebar
          if (keycode == 32) {
            e.preventDefault();
              horitabbedclickevent(this);
          }
          //enter
          else if (keycode == 13) {
              horitabbedclickevent(this);
          }
          //left arrow
          else if (keycode == 37) {
            if ($(this).is(':first-child')) {
              lastchild(this);
            }
            else {
              prevchild(this);
            }
          }
          //right arrow
          else if (keycode == 39) {
            if ($(this).is(':last-child')) {
              firstchild(this);
            }
            else {
              nextchild(this);
            }
          }
          //end
          else if (keycode == 35) {
            e.preventDefault();
            lastchild(this);
          }
          //home
          else if (keycode == 36) {
            e.preventDefault();
            firstchild(this);
          }
      });

      //custom keyboard mapping - hybrid accordion
      accordionanchor.on('keydown', function (e) {

          //var keycode = e.which;
          var keycode = (e.keyCode ? e.keyCode : e.which);

          //spacebar
          if (keycode == 32) {
              e.preventDefault();
              accordionclickevent(this);
          }
          
      });

      function getLastPanelOpened(el) {
        return $(el).closest('.horitabbedpanelblock').data('lastpanelopened');
      }

      function setLastPanelOpened(el, id) {
        $(el).closest('.horitabbedpanelblock').data('lastpanelopened', id);
      }

      function horitabbedclickevent(el) {

          let el_id = $(el).data('panel'),
              panelnav_anchors = $(el).parents('.horitabbedpanelblock .panelnav').find('.tab'),
              panelcontent = $(el).parents('.horitabbedpanelblock').find('.panel');

          setLastPanelOpened(el, el_id);

          //set nav state
          panelnav_anchors.removeClass('active').attr('aria-selected', 'false').attr('tabindex', '-1');
          $(el).addClass('active').attr('aria-selected', 'true').attr('tabindex', '0').focus();

          //set content panel state
          panelcontent.removeClass('active').attr('aria-hidden', 'true').removeAttr('tabindex').find(focuselements).attr('tabindex', '-1');
          $(el).parents('.horitabbedpanelblock').find('.panel[data-id="' + el_id + '"]').addClass('active').attr('aria-hidden', 'false').attr('tabindex', '0').find(focuselements).removeAttr('tabindex');

          //sync nav state on accordion version
          $(el).parents('.horitabbedpanelblock').find('.horitabbedpanelblock__button').removeClass('active').attr('aria-expanded', 'false');
          $(el).parents('.horitabbedpanelblock').find('.horitabbedpanelblock__button[data-panel="' + el_id + '"]').addClass('active').attr('aria-expanded', 'true').focus();
      }

      function accordionclickevent(el) {

        let el_id = $(el).data('panel'),
            accordion_anchors = $(el).parents('.horitabbedpanelblock__accordion-heading').find('.horitabbedpanelblock__button');

          if ($(el).hasClass('active')) {
              accordion_anchors.removeClass('active').attr('aria-expanded', 'false');
              $(el).parents('.horitabbedpanelblock').find('.panel[data-id="' + el_id + '"]').removeClass('active').attr('aria-hidden', 'true').attr('tabindex', '-1').find(focuselements).attr('tabindex', '-1');
              setLastPanelOpened(el, '');
          }
          else {
              $(el).addClass('active').attr('aria-expanded', 'true').focus();
              $(el).parents('.horitabbedpanelblock').find('.panel[data-id="' + el_id + '"]').addClass('active').attr('aria-hidden', 'false').attr('tabindex', '0').find(focuselements).removeAttr('tabindex');
              setLastPanelOpened(el, el_id);
          }

          //sync nav state on horizontal version
          $(el).parents('.horitabbedpanelblock').find('.panelnav').find('.tab').removeClass('active').attr('aria-selected', 'false').attr('tabindex', '-1');
          $(el).parents('.horitabbedpanelblock').find('.panelnav').find('.tab[data-panel="' + el_id + '"]').addClass('active').attr('aria-selected', 'true').attr('tabindex', '0').focus();
      }

      $(window).on('resize-end', function () { 

        $('.horitabbedpanelblock').each(function(){
          
          const inMobile = $(this).find('.panelnav').css('display') != 'none',
                inDesktop = $(this).find('.panelnav').css('display') != 'flex',
                accordion_anchors = $(this).find('.horitabbedpanelblock__accordion-heading .horitabbedpanelblock__button');

          var lastpanelopened = getLastPanelOpened(this);
  
          if (inMobile) {

              $(this).find('.panel').removeClass('active').attr('aria-hidden', 'true').attr('tabindex', '-1').find(focuselements).attr('tabindex', '-1');
              $(this).find('.panel[data-id="' + lastpanelopened + '"]').addClass('active').attr('aria-hidden', 'false').attr('tabindex', '0').find(focuselements).removeAttr('tabindex');

              //reset accordions except active one
              accordion_anchors.removeClass('active').attr('aria-expanded', 'false');
              $(this).find('.horitabbedpanelblock__accordion-heading .horitabbedpanelblock__button[data-panel="' + lastpanelopened + '" ]').addClass('active').attr('aria-expanded', 'true');
          }
          if (inMobile && lastpanelopened == '') {
              
              $(this).find('.panelnav li').removeClass('active').attr('aria-selected', 'true').attr('tabindex', '-1').find(focuselements).attr('tabindex', '-1');
              $(this).find('.panelnav li:first-of-type').addClass('active').attr('aria-selected', 'true').attr('tabindex', '0');
              $(this).find('.panel:first-of-type').addClass('active').attr('aria-hidden', 'false').attr('tabindex', '0').find(focuselements).removeAttr('tabindex');

              //reset all accordions
              accordion_anchors.removeClass('active').attr('aria-expanded', 'false');
          }
          if (inDesktop && lastpanelopened == '') {

              $(this).find('.panel').removeClass('active').attr('aria-hidden', 'true').attr('tabindex', '-1').find(focuselements).removeAttr('tabindex');        
          }

        });

      });

   }
}(jQuery));
